import { Component, Inject, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwControlType, DwOrmDataService, DwOrmDataServiceToken, DwSecurityUserService, DwUser, DwQueryHelper, DwLoggingService } from '@devwareapps/devware-cap';
import { WachterUserExt } from '../../../../shared/models/wachter-user.model';
import { CovidMetaDataService, EmployeeSummaryEntity, CovidConfigurationEntity } from '../../meta-data/covid-meta-data.service';

import * as moment_ from 'moment';
import { CovidHomeView } from '../../models/covid-home-view.enum';
const moment = moment_;

@DwComponent({
  name:'Covid Home',
  key: 'covid_home',
  componentType: DwComponentType.pageComponent,
  isGlobal: true
})
@Component({
  selector: 'app-covid-home',
  templateUrl: './covid-home.component.html',
  styleUrls: ['./covid-home.component.scss']
})
export class CovidHomeComponent implements OnInit {
  textboxControlType : DwControlType = DwControlType.Textbox;
  isAuthenticated: boolean = false;
  trustUserId? : number;
  user: DwUser;
  employeeSummary: EmployeeSummaryEntity;
  covidConfig: CovidConfigurationEntity;

  covidHomeView: CovidHomeView;

  showCovidSection: boolean = false;
  readonly WachterUserType = 497;
  
  constructor(private dwSecurityUserService: DwSecurityUserService, @Inject(DwOrmDataServiceToken) private ormDataService: DwOrmDataService, private dwLoggingSerivce: DwLoggingService) {
  }

  ngOnInit(): void {
     this.dwSecurityUserService.securityContextChanged().subscribe(() => {
      this.setupSecurity();
    });

    this.setupSecurity();
  }

  private loadingUserVendor = false;
  private loadedUserId: number;

  private loadingCovidConfig = false;

  private setupSecurity() {

    if (this.dwSecurityUserService.securityState.isAuthenticating) {
      return;
    }
    
    this.isAuthenticated = this.dwSecurityUserService.securityState.isAuthenticated;

    if (this.isAuthenticated) {
      this.user = this.dwSecurityUserService.securityContext.ApplicationUser;
      const wachterUser = new WachterUserExt(this.user);

      this.trustUserId = wachterUser.trustUserId;

      if (!this.trustUserId) {
        this.dwLoggingSerivce.logToConsole(`Hiding covid information because user does not have a Trust User Id`);

        // If they aren't a Trust user, there is nothing to do here
        return;
      }

      this.loadEmployeeSummary(); 
      this.loadCovidConfig();
    }
  }

  private loadEmployeeSummary() {
    if (!this.trustUserId) {
      return;
    }

    var md = new CovidMetaDataService();
    var qh = new DwQueryHelper();
    var query = md.EmployeeSummary.CreateQuery();

    query.FieldSettings.LoadAllLookupDisplayFields = true;

    query.AddFilterAnd(qh.filters.Equal(md.EmployeeSummary.EmployeeUserId, this.trustUserId));
    query.AddPrefetchPath(md.EmployeeSummary.Relations.EthosUserByEmployeeUserId);

    this.ormDataService.executeQuerySingle(query)
      .subscribe((employeeSummary: EmployeeSummaryEntity) => {
        
        this.employeeSummary = employeeSummary;

        if (!this.employeeSummary) {
          this.dwLoggingSerivce.logToConsole(`Hiding covid information because an employee summary was not found`);
        }

        this.setupPage();
      });
  }

  private loadCovidConfig() {

    if (this.covidConfig || this.loadingCovidConfig) {
      return;
    }

    this.loadingCovidConfig = true;

    var md = new CovidMetaDataService();
    var qh = new DwQueryHelper();
    var query = md.CovidConfiguration.CreateQuery();

    query.AddFilterAnd(qh.filters.LessThanEqual(md.CovidConfiguration.EffectiveStartDate, this.getCurrentDateTime()));
    query.AddFilterAnd(qh.filters.GreaterThanEqual(md.CovidConfiguration.EffectiveEndDate, this.getCurrentDateTime()));
    
    this.ormDataService.executeQuerySingle(query)
      .subscribe((covidConfig: CovidConfigurationEntity) => {
        this.covidConfig = covidConfig;

        if (!this.covidConfig) {
          this.dwLoggingSerivce.logToConsole(`Hiding covid information a valid Covid Configuration record was not found`);
        }
        this.setupPage();
      });
  }

  private setupPage() {
    this.showCovidSection = false;

    // Still Loading
    if (!this.covidConfig || !this.employeeSummary) {
      return;
    }

    // Not valid except for wachter employees
    if (this.employeeSummary.EmployeeEthosUser.UserTypeCv != this.WachterUserType)
    {
      this.dwLoggingSerivce.logToConsole(`Hiding covid information because the user is not a Wachter employee`);
      return;      
    }

    // Defer to config to determine if section should be displayed
    this.showCovidSection = this.covidConfig.ShowHomePageContent;

    if (!this.covidConfig.ShowHomePageContent) {
      this.dwLoggingSerivce.logToConsole(`Hiding covid information because it is turn off in the current Covid Configuration`);
    }

    if (!this.covidConfig.RequireWeeklyTesting) {
      this.covidHomeView = CovidHomeView.wachterNoWeeklyTesting;
      return;
    }

    if (this.employeeSummary.RequiresWeeklyTesting) {
      this.covidHomeView = CovidHomeView.employeeWeeklyTesting;
      return;
    }

    this.covidHomeView = CovidHomeView.employeeNoWeeklyTesting;

  }

  private getCurrentDateTime(): string {
    let dateTimeStr =  moment().utc().format("MM/DD/YYYY hh:mm A")

    return dateTimeStr;
  }
}
